let modules = {}

export const addModules = (newModules) => {
  modules = { ...modules, ...newModules }
}

export const getModule = name => modules[name] || null
